// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"16":"8e67aa58","37":"ae547d9d","46":"dae945d7","388":"aa0f4128","453":"258b012d","695":"681cbfb3"}[chunkId] + ".chunk.js";
};